export const usersingletaskreq="usersingletaskreq"
export const usersingtasksucc="usersingletasksucc"
export const usersingtaskfail="usersingletaskfail"